import React, { useMemo, useState } from 'react';
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaGithub, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import content from '../data/content.json';
import { resolveAssetPath } from '../utils/content';
import './Contact.css';

const contactEmail = content.site?.contact?.email || 'akhilsnair811@gmail.com';
const footerLogo = resolveAssetPath('/assets/brand/Untitleddddd-1.png');

const Contact = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const particles = useMemo(() => {
    return Array.from({ length: 25 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: Math.random() * 4 + 2,
      duration: Math.random() * 10 + 15,
      delay: Math.random() * -10,
      dx: (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 60 + 20),
      dy: (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 60 + 20),
    }));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setStatus({ type: 'error', message: 'Please enter your email address.' });
      return;
    }

    setSubmitting(true);
    setStatus({ type: '', message: '' });

    const subject = encodeURIComponent('New portfolio contact request');
    const body = encodeURIComponent(
      `Visitor email: ${trimmedEmail}\n\nI found your portfolio and wanted to get in touch.`,
    );
    const mailtoUrl = `mailto:${contactEmail}?subject=${subject}&body=${body}`;

    try {
      window.location.href = mailtoUrl;
      setStatus({
        type: 'success',
        message: 'Opening your email app so you can send the message.',
      });
      setEmail('');
    } catch {
      setStatus({
        type: 'error',
        message: 'Unable to open your email app right now.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-email-card">
        <div className="contact-card-texture"></div>

        <div className="contact-card-content">
          <h2 className="contact-card-heading">
            Let's create great things together
          </h2>
          <p className="contact-card-subheading">
            Drop your email and I'll contact you soon ;)
          </p>

          <form className="contact-card-form" onSubmit={handleSubmit}>
            <div className="contact-input-wrapper">
              <input
                type="email"
                placeholder="email here..."
                className="contact-card-input"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                required
              />
              <button
                type="submit"
                className="contact-card-submit"
                aria-label="Send"
                disabled={submitting}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            {status.message ? (
              <p className={`contact-card-status contact-card-status--${status.type}`}>
                {status.message}
              </p>
            ) : null}
          </form>
        </div>

        {particles.length ? (
          <div className="contact-card-particles-container" aria-hidden="true">
            {particles.map((p) => (
              <div
                key={p.id}
                className="contact-card-particle"
                style={{
                  left: `${p.left}%`,
                  top: `${p.top}%`,
                  width: `${p.size}px`,
                  height: `${p.size}px`,
                  '--dx': `${p.dx}px`,
                  '--dy': `${p.dy}px`,
                  animationDuration: `${p.duration}s`,
                  animationDelay: `${p.delay}s`
                }}
              />
            ))}
          </div>
        ) : null}
      </div>

      <div className="contact-footer">
        <div className="social-icons">
          <a href="https://www.facebook.com/" aria-label="Facebook" className="social-link-icon"><FaFacebookF /></a>
          <a href="https://x.com/" aria-label="X" className="social-link-icon"><FaXTwitter /></a>
          <a href="https://www.linkedin.com/in/akhil-sn-a247762b6?utm_source=share_via&utm_content=profile&utm_medium=member_android" aria-label="LinkedIn" className="social-link-icon"><FaLinkedinIn /></a>
          <a href="https://www.instagram.com/akhil.sn_?igsh=MWZtdDhoZ3BuaWk3NA==" aria-label="Instagram" className="social-link-icon"><FaInstagram /></a>
          <a href="https://github.com/AkhilSNair02" aria-label="GitHub" className="social-link-icon"><FaGithub /></a>
          <a href="https://wa.me/7592948950" aria-label="WhatsApp" className="social-link-icon"><FaWhatsapp /></a>
        </div>

        <div className="footer-credits">
          <p className="created-by">
            Created by
            <span className="signature-wrap">
              <img className="footer-brand-logo-image" src={footerLogo} alt="Akhil signature logo" />
            </span>
          </p>
          <p className="copyright">&copy; 2025 - 2026 <span className="red-slashes">|</span> All Rights Reserved</p>
        </div>
      </div>
    </section>
  );
};

export default React.memo(Contact);
